import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Paper, Typography } from '@material-ui/core'
import { size } from 'lodash'

import { Container, ContentHeader, Page, PaperHeader } from 'components'
import {
  ConclusionStep,
  ConfigurationStep,
  FillVariablesStep,
  GenerateDocumentStep,
  LinkControlsStep,
  ReviewStep,
  ApprovalStep,
  StepperActions,
  SelectDocumentTemplateStep,
} from './components'

import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useDocumentGenerate from 'hooks/useDocumentGenerate'

import * as service from 'service'
import { Skeleton } from '@material-ui/lab'
import theme from 'theme'

const DocumentTemplateGenerate = ({ match }) => {
  const { documentTemplateId } = match.params

  const {
    activeStep,
    setControlOrigin,
    setDocumentTemplate,
    setDocumentVariables,
  } = useDocumentGenerate()

  const { search } = useLocation()

  const controlOrigin = helpers.privacyPolicies.parseControlOrigin(search)

  const { response, isLoading } = useFetch(
    service.dponet.documentTemplates.get,
    { documentTemplateId },
    [documentTemplateId],
    !!documentTemplateId,
  )

  const documentTemplate = response?.data?.documentTemplate || {}

  const { response: responseVariables, isLoading: isLoadingVariables } =
    useFetch(
      service.dponet.documentTemplateVariables.get,
      { documentTemplateId },
      [documentTemplateId],
      !!documentTemplateId,
    )

  const documentVariables = responseVariables?.data?.documentVariables || []

  const loadingResponse = isLoading || isLoadingVariables

  const stepNames = [
    ...(!documentTemplateId ? ['Selecione o modelo de documento'] : []),
    'Informações do documento',
    'Gerando seu documento',
    'Revisando seu documento',
    'Aprovação de documento',
    'Configuração do documento',
    'Vincular controles',
    'Seu documento foi gerado com sucesso!',
  ]

  const stepComponents = [
    ...(!documentTemplateId ? [SelectDocumentTemplateStep] : []),
    FillVariablesStep,
    GenerateDocumentStep,
    ReviewStep,
    ApprovalStep,
    ConfigurationStep,
    LinkControlsStep,
    ConclusionStep,
  ]

  useEffect(() => {
    setControlOrigin(controlOrigin)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  useEffect(() => {
    setDocumentTemplate(documentTemplate)
  }, [isLoading])

  useEffect(() => {
    setDocumentVariables(documentVariables)
  }, [isLoadingVariables])

  return (
    <Page title="Modelos Automatizados">
      <Container>
        <ContentHeader title="Modelos Automatizados" />

        <Paper>
          <PaperHeader
            title={stepNames[activeStep]}
            actionButton={
              <Typography variant="body1">
                {`Etapa ${activeStep + 1} de ${size(stepComponents)}`}
              </Typography>
            }
          />

          <Box p={2} pt={0}>
            {loadingResponse ? (
              <Box
                display="flex"
                flexDirection="column"
                gridGap={theme.spacing(2)}
              >
                <Skeleton variant="rect" width="100%" height={88} />
                {Array.from({ length: 5 }, (_, index) => (
                  <Box key={index}>
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={300} />
                    <Skeleton variant="rect" width="100%" height={53} />
                  </Box>
                ))}
              </Box>
            ) : (
              stepComponents[activeStep] &&
              React.createElement(stepComponents[activeStep])
            )}
          </Box>
        </Paper>
        <StepperActions />
      </Container>
    </Page>
  )
}

export default DocumentTemplateGenerate
